var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9143 11H12.1243L11.8443 10.73C12.8583 9.55407 13.4155 8.05271 13.4143 6.5C13.4143 5.21442 13.0331 3.95772 12.3189 2.8888C11.6046 1.81988 10.5895 0.986756 9.40175 0.494786C8.21403 0.00281635 6.9071 -0.125905 5.64622 0.124899C4.38535 0.375703 3.22716 0.994767 2.31812 1.90381C1.40907 2.81285 0.790009 3.97104 0.539205 5.23192C0.288401 6.49279 0.417123 7.79973 0.909093 8.98744C1.40106 10.1752 2.23418 11.1903 3.3031 11.9046C4.37202 12.6188 5.62873 13 6.91431 13C8.52431 13 10.0043 12.41 11.1443 11.43L11.4143 11.71V12.5L16.4143 17.49L17.9043 16L12.9143 11ZM6.91431 11C4.42431 11 2.41431 8.99 2.41431 6.5C2.41431 4.01 4.42431 2 6.91431 2C9.40431 2 11.4143 4.01 11.4143 6.5C11.4143 8.99 9.40431 11 6.91431 11Z",
    fill: "#8B909A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2122d1a30f63aca4f251c3edaad1b4dc.svg";
export { ForwardRef as ReactComponent };